import * as React from 'react';
import { Row, Col } from 'antd';
import { PbrInputMask } from '../PbrInput/PbrInputMask';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import "./PbrInputCode.scss";
import { PbrInput } from '../PbrInput/PbrInput';

export function PbrInputCode(props: {
    formWrapper: WrappedFormUtils,
    name: string
    onChange?: (val: string) => void, style?: React.CSSProperties,
}) {
    const [codeArr, setCodeArr] = React.useState(["", "", "", "", "", ""]);

    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const key = Number(e.target.id.split("num")[1]);

        codeArr[key] = e.target.value;
        props.formWrapper.setFieldsValue({ [props.name]: codeArr.join('') });

        setCodeArr([...codeArr]);
        if (codeArr[key] && key < 5) {
            setTimeout(() => {
                document.getElementById(`num${key + 1}`).focus();
            }, 0);
        }

        if (props.onChange) {
            props.onChange(codeArr.join(''));
        }
    }

    function onKeydown(e: React.KeyboardEvent<HTMLInputElement>) {
        const idx = Number(e.currentTarget.id.split("num")[1]);

        if (e.keyCode === 8 && idx > 0) {
            setTimeout(() => {
                (document.getElementById(`num${idx - 1}`) as any).select();
            }, 0);

        }
    }

    return (
        <Row className="input-code" style={{ ...props.style }}>
            {
                codeArr.map((val, idx) => (
                    <Col span={4} key={idx} className="code-col">
                        <PbrInputMask mask="9" maskChar={null}
                            onChange={(e) => onChange(e)}
                            onKeyDown={(e) => onKeydown(e)}
                            autoFocus={idx === 0}
                            style={{
                                borderRadius: "3px",
                                textAlign: "center",
                            }} name={`num${idx}`} id={`num${idx}`} autoComplete="off" />
                    </Col>
                ))
            }
            <Col span={24}>
                <PbrInput name={props.name} formWrapper={props.formWrapper}
                    style={{ display: "none" }}
                    rules={[{
                        required: true,
                        message: 'Informe o código de verificação!'
                    }, {
                        min: 6,
                        message: 'Informe um código com 6 dígitos!'
                    }]} />
            </Col>
        </Row>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/PbrInputCode/PbrInputCode.tsx